<div
    class="bg-$color-bg-header fixed top-0 left-0 w-full pt-$safe-area-top z-50 backdrop-filter backdrop-blur-lg border-b-1 border-b-black border-opacity-15 rounded-b-lg overflow-hidden touch-none"
>
    <div
        class="text-$color-text-header font-bold text-lg h-3rem w-full flex flex-row items-center justify-center"
    >
        <slot name="title">Header</slot>
    </div>
</div>
